import { render, staticRenderFns } from "./Login2.vue?vue&type=template&id=34f3c5f2&scoped=true&"
import script from "./Login2.vue?vue&type=script&lang=js&"
export * from "./Login2.vue?vue&type=script&lang=js&"
import style0 from "./Login2.vue?vue&type=style&index=0&id=34f3c5f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f3c5f2",
  null
  
)

component.options.__file = "Login2.vue"
export default component.exports